function r(c, i) {
  let l = 0, a = 1e3 / i, e, t;
  const u = (n, o = Date.now()) => {
    l = o, e = null, t && (clearTimeout(t), t = null), c(...n);
  };
  return [(...n) => {
    const o = Date.now(), s = o - l;
    s >= a ? u(n, o) : (e = n, t || (t = setTimeout(() => {
      t = null, u(e);
    }, a - s)));
  }, () => e && u(e)];
}
export {
  r as default
};
//# sourceMappingURL=index.es411.js.map
